import { WEBFLOW_BASE_URL } from "@/utils";
import { Button } from "./ui/button";

export const BlogPosts = () => {
  return (
    <div className="flex flex-col xl:flex-row xl:justify-between bg-custom-light-blue/60 rounded-lg py-2 w-full md:gap-24 px-[10%]">
      <img src="/checkout-success/illustration.svg" />

      <div className="flex flex-col gap-6">
        <p className="text-center text-[32px] md:text-5xl font-bold">
          Want to learn more about miles?
        </p>

        <Button
          // onClick={handleSubmitNewQuote}
          onClick={() => {
            window.location.href = `${WEBFLOW_BASE_URL}/blog`;
          }}
          className="uppercase rounded-sm w-fit mx-auto px-14 py-6"
        >
          Read our blog posts
        </Button>
      </div>
    </div>
  );
};
